import ExceptionIssue from '../model/ExceptionIssue'
import UnhandledException from '../model/UnhandledException'
import { configuration } from './Configuration'
import fetch from 'isomorphic-fetch'

class ExceptionApi {
  raiseException(unhandled: UnhandledException): Promise<ExceptionIssue> {
    if (configuration.ExceptionAPI) {
      return this.raiseExceptionFromURL(configuration.ExceptionAPI, unhandled)
    } else {
      return new Promise(() => {
        var issue = new ExceptionIssue()
        issue.Address = 'n/a'
        issue.IsNew = true
        issue.Number = -1
        return issue
      })
    }
  }
  raiseExceptionFromURL(url: string, unhandled: UnhandledException): Promise<ExceptionIssue> {
    var json = JSON.stringify(unhandled)
    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: json
    }).then((response: Response) => {
      if (response.status === 200) {
        return response.json()
      }
      return null
    })
  }
}

export const exceptionApi = new ExceptionApi()
